module.exports = __webpack_public_path__ + "img/icon-gray3.2bb14d66.png";